import {PaymentChannel} from "../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {SitemapHelper} from "../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
export class OnAuthenticatedSession {
  constructor($rootScope, sessionService, naviService, invoicesService) {
    const setRole = () => {
      const session = sessionService.session;
      const partnerId = session.settings.partner.accountId;
      const customerId = session.currentAccount.id;
      if (partnerId === "FI36POYO0020747494" || partnerId === "FI81POYS0016206791" || customerId === "FI53POYS0025543933" || customerId === "FI68POYH0028711058" || customerId === "FI42POYT0025991058" || customerId === "FI36POYH0032589403" || customerId === "FI61POYT0027579091") {
        sessionService.clientRoles.push("newPayroll");
      }
      if (partnerId === "FI81POYS0016206791") {
        sessionService.clientRoles.push("setSalaryDateKind");
      }
    };
    const setSiteMap = () => {
      const session = sessionService.session;
      const customerId = session.currentAccount.id;
      if (customerId === "FI36POYH0032589403") {
        const sitemap = SitemapHelper.getCompanySiteMap();
        const calculations = sitemap.find((x) => x.id === "calculations");
        calculations.children.find((x) => x.id === "importCalcs").roles = null;
        const workers = sitemap.find((x) => x.id === "workers");
        workers.children.find((x) => x.id === "importWorkers").roles = null;
        naviService.setSitemap(sitemap);
      }
    };
    const setPaymentChannel = () => {
      if (sessionService.session.currentAccount.id == "FI53POYS0025543933") {
        if (!sessionService.session.settings.paymentChannels.some((x) => x === PaymentChannel.PalkkausWS)) {
          sessionService.session.settings.paymentChannels.push(PaymentChannel.PalkkausWS);
        }
        invoicesService.defaultPaymentListChannel = PaymentChannel.PalkkausWS;
        sessionService.clientRoles.push("invoicePaymentList");
        naviService.updateSitemapInRole();
      }
    };
    if (sessionService.isSessionChecked && sessionService.isAuthenticated) {
      setRole();
      setSiteMap();
      setPaymentChannel();
    }
    sessionService.onAuthenticatedSession($rootScope, () => {
      setRole();
      setSiteMap();
      setPaymentChannel();
    });
  }
}
OnAuthenticatedSession.$inject = [
  "$rootScope",
  "SessionService",
  "NaviService",
  "InvoicesService"
];
